<template>  
  <v-container fluid class="container-full-bg-gray" v-if="got_feature('feature_can_use_payable_or_receivable_effects')">      
    <bank-effects-table v-if="currentCompany" ref="effectsTable"></bank-effects-table>
  </v-container>       
</template>


<script>
import { mapGetters, mapState } from "vuex";
import BankEffectsTable from "@/components/BankEffectsTable.vue";


export default {
  name: 'BankEffectsList',  
  components: {
    BankEffectsTable,    
  },
  data() {
    return {
      
    }
  },
  computed: {
    ...mapState(['currentCompany']),    
    ...mapGetters({
      userData: 'me/userData',            
      permission: 'permissions/permission',
      got_feature:'got_feature',
    }),   

  },
  watch: {
    currentCompany(newValue, oldValue) {      
      if (oldValue != null) {
        this.$router.push({name: 'bank-effects', params: {'company_id': this.currentCompany.id}});
      }
      
    }
  },
    
  async created() {
   
  },

  async mounted() {   
  },  
 
  methods: {
    
  },

    
}

</script> 

<style scoped> 
  .primary-bckground {
    background-color: var(--v-primary-base);
  }
</style>